export var LinkVariantType;
(function (LinkVariantType) {
    LinkVariantType["PRIMARY"] = "PRIMARY";
    LinkVariantType["SECONDARY"] = "SECONDARY";
    LinkVariantType["MAIN_SECTION_HEADERS"] = "MAIN_SECTION_HEADERS";
    LinkVariantType["SECONDARY_ON_SURFACE"] = "SECONDARY_ON_SURFACE";
    LinkVariantType["PRIMARY_CONTACT_CENTER"] = "PRIMARY_CONTACT_CENTER";
    LinkVariantType["UNSTYLED"] = "UNSTYLED";
})(LinkVariantType || (LinkVariantType = {}));
/**
 * @deprecated Use `LinkVariantType` instead.
 */
export var NavigationLinkVariantType;
(function (NavigationLinkVariantType) {
    NavigationLinkVariantType["PRIMARY"] = "PRIMARY";
    NavigationLinkVariantType["SECONDARY"] = "SECONDARY";
    NavigationLinkVariantType["MAIN_SECTION_HEADERS"] = "MAIN_SECTION_HEADERS";
    NavigationLinkVariantType["SECONDARY_ON_SURFACE"] = "SECONDARY_ON_SURFACE";
    NavigationLinkVariantType["UNSTYLED"] = "UNSTYLED";
})(NavigationLinkVariantType || (NavigationLinkVariantType = {}));
//# sourceMappingURL=variants.js.map